<div class="header">
    <strong>AVALIADOR</strong>
    <strong>DATA INÍCIO</strong>
    <strong>DURAÇÃO</strong>
    <strong>CLIENTE</strong>
    <strong>CÉLULA</strong>
    <strong>SUB-CÉLULA</strong>
    <strong>PROGRESSO</strong>
    <strong>STATUS</strong>
    <strong>AÇÕES</strong>
  </div>
